import * as React from "react";
import { forwardRef } from "react";
const SvgVector175 = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 19,
	height: 26,
	viewBox: "0 0 19 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M1 1L18 13.5714L1 25",
	stroke: "#4B4D4B",
	strokeLinecap: "round"
}));
const ForwardRef = forwardRef(SvgVector175);
export default ForwardRef;
